import { queryOptions } from '@tanstack/react-query';
import { meResponseSchema, type MeResponse } from '@klopotun/contracts';
import { apiRequest } from '../../../shared/api/index.js';

const getMe = async (signal: AbortSignal): Promise<MeResponse> =>
  meResponseSchema.parse(await apiRequest<unknown>('/me', { signal }));

export const meQueries = {
  all: () => ['me'] as const,
  current: () =>
    queryOptions({
      queryKey: meQueries.all(),
      queryFn: ({ signal }) => getMe(signal),
    }),
};
